import { Checkbox, CheckboxGroup, Text } from "@instructure/ui";
import { t } from "i18next";

const VarietyCheckbox = ({ filters, selectHandler }) => {
  return (
    <CheckboxGroup
      name={t("dashboard.loVariety")}
      description={<Text size="small">{t("dashboard.displayResultsFor")}</Text>}
      size="small"
      layout="columns"
      value={filters.variety}
      onChange={selectHandler}
      disabled={filters.LOType === "CSLO"}
    >
      <Checkbox label={t("dashboard.los")} value="outcome" />
      <Checkbox label={t("dashboard.standards")} value="standard" />
    </CheckboxGroup>
  );
};

export default VarietyCheckbox;
